module.exports = __webpack_public_path__ + "img/logo_xs.984c5832.svg";